module.exports={account_link_complete_message:"넥슨계정 연동이 완료되었습니다."};